import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes, NoPreloading } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { CommonService } from '@services/app.common.service';
import { SharedModule } from './shared.module';
import { AppHeaderComponent } from './_shared/_layout/app-header/app-header.component';
import { FooterComponent } from './_shared/_layout/app-footer/footer.component';
import { AppLayoutComponent } from './_shared/_layout/app-Layout/app-layout.component';
import { AuthenticationService } from '@services/authentication.service';
import { RoleAccessService } from '@services/role.access.service';
import { AuthGuardService } from '@services/auth-guard.service';
import { AccessGuardService } from '@services/access.gaurd.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomTranslateLoader } from '@services/app-customtranslation.loader';
import { ForgotPasswordComponent } from './login/forgotPassword.component';
import { IdServer } from './_shared/_enums/idServer';
import { TokenResolver } from './_shared/resolver/token.resolver';
import { DataPassService } from '@services/app.datapass.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AlertService } from '@services/alert.service';
import { SvgIconModule } from './_shared/_customcomponent/Icons/_svg/app-jt-svg-icon.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DynamicScriptLoaderService } from '@services/dynamicScriptLoaderService';
import { SSORedirectComponent } from './ssoRedirect/ssoRedirect.component';
import { TwoFactorAuthenticationService } from './_shared/_services/two-factor-authentication.service';
const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'Login1', component: LoginComponent },
  {
    path: 'ForgotPassword', component: ForgotPasswordComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous }
  },


  {
    path: 'Home',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Search',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/search/search.module').then(m => m.SearchModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'NewStarters',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/newStarters/newStarters.module').then(m => m.NewStartersModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'Contacts',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/contacts/contacts.module').then(m => m.ContactsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'TalentPool',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/talentPool/talentPool.module').then(m => m.TalentPoolModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'Notification',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'SendSms',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/sendSms/sendSms.module').then(m => m.SendSmsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'Test',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/_shared/_component/assessmentFormTest/assessmentFormTest.module').then(m => m.AssessmentFormTestModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },



  {
    path: 'MyJobs',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/myJobs/myJobs.module').then(m => m.myJobsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'CandidateList',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/candidateList/candidateList.module').then(m => m.CandidateListModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Candidate',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/candidates/candidates.module').then(m => m.CandidateModule)
  },

  {
    path: 'Interviews',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/interviews/interviews.module').then(m => m.InterviewsModule)
  },
  {
    path: 'MsSSORedirect', component: SSORedirectComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Sso }
  },

  {
    path: '2FA',
    loadChildren: () => import('../app/login/two-factor-authentication/two-factor-authentication.module').then(m => m.TwoFactorAuthenticationModule)
  },



]
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    AppLayoutComponent,
    AppHeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    //LoadingSpinnerModule,
    SharedModule,
    SvgIconModule,
    RouterModule.forRoot(appRoutes, {
    preloadingStrategy: NoPreloading,
    relativeLinkResolution: 'legacy'
}),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    }),
    InfiniteScrollModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    
  ],
  providers: [
    CommonService,
    AuthenticationService,
    TwoFactorAuthenticationService,
    RoleAccessService,
    AccessGuardService,
    AuthGuardService,
    TokenResolver,
    DataPassService,
    AlertService,
    DynamicScriptLoaderService,


  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
